










import Vue from "vue";
export default Vue.extend({
  props: {
    fonts: { type: Object },
    colors: { type: Object }
  }
});
